export const ROWS_PER_PAGE = 20

export const paginationConfigs = {
    limit: 10
}
